// GENERATED FILE, PLEASE DO NOT EDIT
var BannerLabel = {
  RegularDensity: {
    MobileWidth: {
      size: 16,
      weight: 'TTNorms-Medium',
      lineHeight: 22,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 16,
      weight: 'TTNorms-Medium',
      lineHeight: 22,
      letterSpacing: 0
    }
  }
};
var BannerBody = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var ButtonSmallTitle = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 16,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 16,
      letterSpacing: 0
    }
  }
};
var ButtonSmallSubtitle = {
  RegularDensity: {
    MobileWidth: {
      size: 12,
      weight: 'TTNorms-Medium',
      lineHeight: 14,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 12,
      weight: 'TTNorms-Medium',
      lineHeight: 14,
      letterSpacing: 0
    }
  }
};
var ButtonSmallLeading = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 16,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 16,
      letterSpacing: 0
    }
  }
};
var ButtonSmallTrailing = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 16,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 16,
      letterSpacing: 0
    }
  }
};
var ButtonMediumTitle = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 16,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 16,
      letterSpacing: 0
    }
  }
};
var ButtonMediumSubtitle = {
  RegularDensity: {
    MobileWidth: {
      size: 12,
      weight: 'TTNorms-Medium',
      lineHeight: 14,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 12,
      weight: 'TTNorms-Medium',
      lineHeight: 14,
      letterSpacing: 0
    }
  }
};
var ButtonMediumLeading = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 16,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 16,
      letterSpacing: 0
    }
  }
};
var ButtonMediumTrailing = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 16,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 16,
      letterSpacing: 0
    }
  }
};
var ButtonLargeTitle = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 16,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 16,
      letterSpacing: 0
    }
  }
};
var ButtonLargeSubtitle = {
  RegularDensity: {
    MobileWidth: {
      size: 12,
      weight: 'TTNorms-Medium',
      lineHeight: 14,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 12,
      weight: 'TTNorms-Medium',
      lineHeight: 14,
      letterSpacing: 0
    }
  }
};
var ButtonLargeLeading = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 16,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 16,
      letterSpacing: 0
    }
  }
};
var ButtonLargeTrailing = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 16,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 16,
      letterSpacing: 0
    }
  }
};
var ButtonTabSmallUnselected = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 16,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 16,
      letterSpacing: 0
    }
  }
};
var ButtonTabSmallSelected = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 16,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 16,
      letterSpacing: 0
    }
  }
};
var ButtonTabMediumUnselected = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 16,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 16,
      letterSpacing: 0
    }
  }
};
var ButtonTabMediumSelected = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 16,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 16,
      letterSpacing: 0
    }
  }
};
var ButtonTabLargeUnselected = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 16,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 16,
      letterSpacing: 0
    }
  }
};
var ButtonTabLargeSelected = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 16,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 16,
      letterSpacing: 0
    }
  }
};
var FieldSmallLabel = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var FieldSmallInput = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var FieldSmallDescription = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var FieldSmallError = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var FieldSmallHint = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var FieldSmallButton = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var FieldMediumLabel = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var FieldMediumInput = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var FieldMediumDescription = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var FieldMediumError = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var FieldMediumHint = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var FieldMediumButton = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var FieldLargeLabel = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var FieldLargeInput = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var FieldLargeDescription = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var FieldLargeError = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var FieldLargeHint = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var FieldLargeButton = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var MapUITextOnMapUnselected = {
  RegularDensity: {
    MobileWidth: {
      size: 10,
      weight: 'TTNorms-Medium',
      lineHeight: 12,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 10,
      weight: 'TTNorms-Medium',
      lineHeight: 12,
      letterSpacing: 0
    }
  }
};
var MapUITextOnMapSelected = {
  RegularDensity: {
    MobileWidth: {
      size: 12,
      weight: 'TTNorms-Medium',
      lineHeight: 14,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 12,
      weight: 'TTNorms-Medium',
      lineHeight: 14,
      letterSpacing: 0
    }
  }
};
var MenuSmallBody = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var MenuMediumBody = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var MenuLargeBody = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var NavBarExpandedTitle = {
  RegularDensity: {
    MobileWidth: {
      size: 24,
      weight: 'TTNorms-Bold',
      lineHeight: 32,
      letterSpacing: -0.01
    },
    DesktopWidth: {
      size: 24,
      weight: 'TTNorms-Bold',
      lineHeight: 32,
      letterSpacing: -0.01
    }
  }
};
var NavBarExpandedSubtitle = {
  RegularDensity: {
    MobileWidth: {
      size: 12,
      weight: 'TTNorms-Regular',
      lineHeight: 16,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 12,
      weight: 'TTNorms-Regular',
      lineHeight: 16,
      letterSpacing: 0
    }
  }
};
var NavBarCollapsedTitle = {
  RegularDensity: {
    MobileWidth: {
      size: 16,
      weight: 'TTNorms-Medium',
      lineHeight: 22,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 16,
      weight: 'TTNorms-Medium',
      lineHeight: 22,
      letterSpacing: 0
    }
  }
};
var NavBarCollapsedSubtitle = {
  RegularDensity: {
    MobileWidth: {
      size: 12,
      weight: 'TTNorms-Regular',
      lineHeight: 18,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 12,
      weight: 'TTNorms-Regular',
      lineHeight: 18,
      letterSpacing: 0
    }
  }
};
var NavBarExpandedAction = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var NavBarCollapsedAction = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var NumericSmall = {
  RegularDensity: {
    MobileWidth: {
      size: 20,
      weight: 'TTNorms-Medium',
      lineHeight: 24,
      letterSpacing: -0.01
    },
    DesktopWidth: {
      size: 20,
      weight: 'TTNorms-Medium',
      lineHeight: 24,
      letterSpacing: -0.01
    }
  }
};
var NumericMedium = {
  RegularDensity: {
    MobileWidth: {
      size: 24,
      weight: 'TTNorms-Medium',
      lineHeight: 32,
      letterSpacing: -0.01
    },
    DesktopWidth: {
      size: 24,
      weight: 'TTNorms-Medium',
      lineHeight: 32,
      letterSpacing: -0.01
    }
  }
};
var NumericLarge = {
  RegularDensity: {
    MobileWidth: {
      size: 32,
      weight: 'TTNorms-Medium',
      lineHeight: 40,
      letterSpacing: -0.02
    },
    DesktopWidth: {
      size: 32,
      weight: 'TTNorms-Medium',
      lineHeight: 40,
      letterSpacing: -0.02
    }
  }
};
var PaginationNumberedAction = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var PaginationNumberedDescription = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var SliderMediumLabel = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var StepperFloatingSmallValue = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var StepperFloatingSmallUnitCollapsed = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var StepperFloatingSmallUnitExpanded = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var StepperFormSmallValue = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var StepperFormSmallUnit = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var StepperPageLargeValue = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var StepperPageLargeUnit = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var StepperSmallLabel = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var StepperMediumLabel = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var StepperLargeLabel = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var TagXSmallLabel = {
  RegularDensity: {
    MobileWidth: {
      size: 8,
      weight: 'TTNorms-Bold',
      lineHeight: 8,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 8,
      weight: 'TTNorms-Bold',
      lineHeight: 8,
      letterSpacing: 0
    }
  }
};
var TagSmallLabel = {
  RegularDensity: {
    MobileWidth: {
      size: 12,
      weight: 'TTNorms-Medium',
      lineHeight: 18,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 12,
      weight: 'TTNorms-Medium',
      lineHeight: 18,
      letterSpacing: 0
    }
  }
};
var TagMediumLabel = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var TagLargeLabel = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var TableMediumHeader = {
  RegularDensity: {
    MobileWidth: {
      size: 12,
      weight: 'TTNorms-Medium',
      lineHeight: 18,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 12,
      weight: 'TTNorms-Medium',
      lineHeight: 18,
      letterSpacing: 0
    }
  }
};
var TableMediumBody = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var TableMediumLink = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var ToastBody = {
  RegularDensity: {
    MobileWidth: {
      size: 16,
      weight: 'TTNorms-Regular',
      lineHeight: 22,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 16,
      weight: 'TTNorms-Regular',
      lineHeight: 22,
      letterSpacing: 0
    }
  }
};
var ToastAction = {
  RegularDensity: {
    MobileWidth: {
      size: 16,
      weight: 'TTNorms-Medium',
      lineHeight: 22,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 16,
      weight: 'TTNorms-Medium',
      lineHeight: 22,
      letterSpacing: 0
    }
  }
};
var TooltipLabel = {
  RegularDensity: {
    MobileWidth: {
      size: 16,
      weight: 'TTNorms-Medium',
      lineHeight: 22,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 16,
      weight: 'TTNorms-Medium',
      lineHeight: 22,
      letterSpacing: 0
    }
  }
};
var TooltipBody = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var PageTitle1 = {
  RegularDensity: {
    MobileWidth: {
      size: 32,
      weight: 'TTNorms-Bold',
      lineHeight: 40,
      letterSpacing: -0.02
    },
    DesktopWidth: {
      size: 32,
      weight: 'TTNorms-Bold',
      lineHeight: 40,
      letterSpacing: -0.02
    }
  }
};
var PageTitle2 = {
  RegularDensity: {
    MobileWidth: {
      size: 24,
      weight: 'TTNorms-Regular',
      lineHeight: 32,
      letterSpacing: -0.02
    },
    DesktopWidth: {
      size: 24,
      weight: 'TTNorms-Regular',
      lineHeight: 32,
      letterSpacing: -0.02
    }
  }
};
var Title1 = {
  RegularDensity: {
    MobileWidth: {
      size: 24,
      weight: 'TTNorms-Bold',
      lineHeight: 32,
      letterSpacing: -0.01
    },
    DesktopWidth: {
      size: 24,
      weight: 'TTNorms-Bold',
      lineHeight: 32,
      letterSpacing: -0.01
    }
  }
};
var Title2 = {
  RegularDensity: {
    MobileWidth: {
      size: 20,
      weight: 'TTNorms-Bold',
      lineHeight: 24,
      letterSpacing: -0.01
    },
    DesktopWidth: {
      size: 20,
      weight: 'TTNorms-Bold',
      lineHeight: 24,
      letterSpacing: -0.01
    }
  }
};
var Body1Emphasis = {
  RegularDensity: {
    MobileWidth: {
      size: 16,
      weight: 'TTNorms-Medium',
      lineHeight: 22,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 16,
      weight: 'TTNorms-Medium',
      lineHeight: 22,
      letterSpacing: 0
    }
  }
};
var Body1 = {
  RegularDensity: {
    MobileWidth: {
      size: 16,
      weight: 'TTNorms-Regular',
      lineHeight: 22,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 16,
      weight: 'TTNorms-Regular',
      lineHeight: 22,
      letterSpacing: 0
    }
  }
};
var Body2Emphasis = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var Body2 = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var Label1Emphasis = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Medium',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var Label1 = {
  RegularDensity: {
    MobileWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 14,
      weight: 'TTNorms-Regular',
      lineHeight: 20,
      letterSpacing: 0
    }
  }
};
var Label2Emphasis = {
  RegularDensity: {
    MobileWidth: {
      size: 12,
      weight: 'TTNorms-Medium',
      lineHeight: 18,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 12,
      weight: 'TTNorms-Medium',
      lineHeight: 18,
      letterSpacing: 0
    }
  }
};
var Label2 = {
  RegularDensity: {
    MobileWidth: {
      size: 12,
      weight: 'TTNorms-Regular',
      lineHeight: 18,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 12,
      weight: 'TTNorms-Regular',
      lineHeight: 18,
      letterSpacing: 0
    }
  }
};
var Caption1 = {
  RegularDensity: {
    MobileWidth: {
      size: 12,
      weight: 'TTNorms-Regular',
      lineHeight: 18,
      letterSpacing: 0
    },
    DesktopWidth: {
      size: 12,
      weight: 'TTNorms-Regular',
      lineHeight: 18,
      letterSpacing: 0
    }
  }
};
var Caption2 = {
  RegularDensity: {
    MobileWidth: {
      size: 10,
      weight: 'TTNorms-Medium',
      lineHeight: 16,
      letterSpacing: 0.01
    },
    DesktopWidth: {
      size: 10,
      weight: 'TTNorms-Medium',
      lineHeight: 16,
      letterSpacing: 0.01
    }
  }
};
var TextStyleSemanticsAll = {
  BannerLabel: BannerLabel,
  BannerBody: BannerBody,
  ButtonSmallTitle: ButtonSmallTitle,
  ButtonSmallSubtitle: ButtonSmallSubtitle,
  ButtonSmallLeading: ButtonSmallLeading,
  ButtonSmallTrailing: ButtonSmallTrailing,
  ButtonMediumTitle: ButtonMediumTitle,
  ButtonMediumSubtitle: ButtonMediumSubtitle,
  ButtonMediumLeading: ButtonMediumLeading,
  ButtonMediumTrailing: ButtonMediumTrailing,
  ButtonLargeTitle: ButtonLargeTitle,
  ButtonLargeSubtitle: ButtonLargeSubtitle,
  ButtonLargeLeading: ButtonLargeLeading,
  ButtonLargeTrailing: ButtonLargeTrailing,
  ButtonTabSmallUnselected: ButtonTabSmallUnselected,
  ButtonTabSmallSelected: ButtonTabSmallSelected,
  ButtonTabMediumUnselected: ButtonTabMediumUnselected,
  ButtonTabMediumSelected: ButtonTabMediumSelected,
  ButtonTabLargeUnselected: ButtonTabLargeUnselected,
  ButtonTabLargeSelected: ButtonTabLargeSelected,
  FieldSmallLabel: FieldSmallLabel,
  FieldSmallInput: FieldSmallInput,
  FieldSmallDescription: FieldSmallDescription,
  FieldSmallError: FieldSmallError,
  FieldSmallHint: FieldSmallHint,
  FieldSmallButton: FieldSmallButton,
  FieldMediumLabel: FieldMediumLabel,
  FieldMediumInput: FieldMediumInput,
  FieldMediumDescription: FieldMediumDescription,
  FieldMediumError: FieldMediumError,
  FieldMediumHint: FieldMediumHint,
  FieldMediumButton: FieldMediumButton,
  FieldLargeLabel: FieldLargeLabel,
  FieldLargeInput: FieldLargeInput,
  FieldLargeDescription: FieldLargeDescription,
  FieldLargeError: FieldLargeError,
  FieldLargeHint: FieldLargeHint,
  FieldLargeButton: FieldLargeButton,
  MapUITextOnMapUnselected: MapUITextOnMapUnselected,
  MapUITextOnMapSelected: MapUITextOnMapSelected,
  MenuSmallBody: MenuSmallBody,
  MenuMediumBody: MenuMediumBody,
  MenuLargeBody: MenuLargeBody,
  NavBarExpandedTitle: NavBarExpandedTitle,
  NavBarExpandedSubtitle: NavBarExpandedSubtitle,
  NavBarCollapsedTitle: NavBarCollapsedTitle,
  NavBarCollapsedSubtitle: NavBarCollapsedSubtitle,
  NavBarExpandedAction: NavBarExpandedAction,
  NavBarCollapsedAction: NavBarCollapsedAction,
  NumericSmall: NumericSmall,
  NumericMedium: NumericMedium,
  NumericLarge: NumericLarge,
  PaginationNumberedAction: PaginationNumberedAction,
  PaginationNumberedDescription: PaginationNumberedDescription,
  SliderMediumLabel: SliderMediumLabel,
  StepperFloatingSmallValue: StepperFloatingSmallValue,
  StepperFloatingSmallUnitCollapsed: StepperFloatingSmallUnitCollapsed,
  StepperFloatingSmallUnitExpanded: StepperFloatingSmallUnitExpanded,
  StepperFormSmallValue: StepperFormSmallValue,
  StepperFormSmallUnit: StepperFormSmallUnit,
  StepperPageLargeValue: StepperPageLargeValue,
  StepperPageLargeUnit: StepperPageLargeUnit,
  StepperSmallLabel: StepperSmallLabel,
  StepperMediumLabel: StepperMediumLabel,
  StepperLargeLabel: StepperLargeLabel,
  TagXSmallLabel: TagXSmallLabel,
  TagSmallLabel: TagSmallLabel,
  TagMediumLabel: TagMediumLabel,
  TagLargeLabel: TagLargeLabel,
  TableMediumHeader: TableMediumHeader,
  TableMediumBody: TableMediumBody,
  TableMediumLink: TableMediumLink,
  ToastBody: ToastBody,
  ToastAction: ToastAction,
  TooltipLabel: TooltipLabel,
  TooltipBody: TooltipBody,
  PageTitle1: PageTitle1,
  PageTitle2: PageTitle2,
  Title1: Title1,
  Title2: Title2,
  Body1Emphasis: Body1Emphasis,
  Body1: Body1,
  Body2Emphasis: Body2Emphasis,
  Body2: Body2,
  Label1Emphasis: Label1Emphasis,
  Label1: Label1,
  Label2Emphasis: Label2Emphasis,
  Label2: Label2,
  Caption1: Caption1,
  Caption2: Caption2
};

export { BannerBody, BannerLabel, Body1, Body1Emphasis, Body2, Body2Emphasis, ButtonLargeLeading, ButtonLargeSubtitle, ButtonLargeTitle, ButtonLargeTrailing, ButtonMediumLeading, ButtonMediumSubtitle, ButtonMediumTitle, ButtonMediumTrailing, ButtonSmallLeading, ButtonSmallSubtitle, ButtonSmallTitle, ButtonSmallTrailing, ButtonTabLargeSelected, ButtonTabLargeUnselected, ButtonTabMediumSelected, ButtonTabMediumUnselected, ButtonTabSmallSelected, ButtonTabSmallUnselected, Caption1, Caption2, FieldLargeButton, FieldLargeDescription, FieldLargeError, FieldLargeHint, FieldLargeInput, FieldLargeLabel, FieldMediumButton, FieldMediumDescription, FieldMediumError, FieldMediumHint, FieldMediumInput, FieldMediumLabel, FieldSmallButton, FieldSmallDescription, FieldSmallError, FieldSmallHint, FieldSmallInput, FieldSmallLabel, Label1, Label1Emphasis, Label2, Label2Emphasis, MapUITextOnMapSelected, MapUITextOnMapUnselected, MenuLargeBody, MenuMediumBody, MenuSmallBody, NavBarCollapsedAction, NavBarCollapsedSubtitle, NavBarCollapsedTitle, NavBarExpandedAction, NavBarExpandedSubtitle, NavBarExpandedTitle, NumericLarge, NumericMedium, NumericSmall, PageTitle1, PageTitle2, PaginationNumberedAction, PaginationNumberedDescription, SliderMediumLabel, StepperFloatingSmallUnitCollapsed, StepperFloatingSmallUnitExpanded, StepperFloatingSmallValue, StepperFormSmallUnit, StepperFormSmallValue, StepperLargeLabel, StepperMediumLabel, StepperPageLargeUnit, StepperPageLargeValue, StepperSmallLabel, TableMediumBody, TableMediumHeader, TableMediumLink, TagLargeLabel, TagMediumLabel, TagSmallLabel, TagXSmallLabel, TextStyleSemanticsAll, Title1, Title2, ToastAction, ToastBody, TooltipBody, TooltipLabel, TextStyleSemanticsAll as default };
